<div class="modal-container">
    <div class="modal-header d-inline-block">
        <div class="d-flex justify-content-end">
          <p (click)="bsModalRef.hide()" class="modal-clost-btn" aria-label="Close">&times;</p>
        </div>
        <div>
          <h5 class="title" id="exampleModalLabel">What kind of property are you looking to list?</h5>
        </div>
      </div>
      <div class="modal-body">
        <div class="d-flex justify-content-between">
          <div class="types-container" data-test="entire-property" (click)="navigeToProperty(occupancy_types.SINGLE)" >
             <fa-icon [classes]="['fa-2x']" [icon]="icons.building"></fa-icon>
             <h6 class="title">Single Occupancy</h6>
             <p class="desc">List a property or apartment with one tenancy agreement</p>
          </div>
          <div class="types-container" data-test="shared-property" (click)="navigeToProperty(occupancy_types.SHARED)">
            <fa-icon [classes]="['fa-2x']" [icon]="icons.usersClass"></fa-icon>
            <h6 class="title">Shared Occupancy</h6>
            <p class="desc">List a property or apartment with multiple tenancy agreements</p>
         </div>
        </div>
      </div>
</div>
